import { render, staticRenderFns } from "./StationSelect.vue?vue&type=template&id=53c810c2&scoped=true&"
import script from "./StationSelect.vue?vue&type=script&lang=js&"
export * from "./StationSelect.vue?vue&type=script&lang=js&"
import style0 from "./StationSelect.vue?vue&type=style&index=0&id=53c810c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c810c2",
  null
  
)

export default component.exports